import type { Router, RouteRecordRaw } from "vue-router"
import OneComponentLayout from "@/app/layouts/OneComponentLayout.vue"
import NotFoundPage from "@/app/views/NotFoundPage.vue"
import { casinoRoutes } from "@/casino/routes/casino"

import { survivorRoutes } from "@/survivor/routes/survivor"
import {
  createRouter,
  createWebHistory,

  useRoute,
} from "vue-router"
import { registerRouterGuards } from "./router-guards"
import { utilityRoutes } from "./routes"

const routes: RouteRecordRaw[] = [
  utilityRoutes,
  casinoRoutes,
  survivorRoutes,
  {
    path: "/:pathMatch(.*)*",
    name: "not-found-wrapper",
    component: OneComponentLayout,
    children: [
      {
        path: "",
        name: "not-found",
        component: NotFoundPage,
      },
    ],
  },
]

declare module "vue-router" {
  interface RouteMeta {
    requiresAuth?: boolean
    excludesAuth?: boolean
    backRoute?: string
  }
}

const router: Router = createRouter({
  history: createWebHistory(),
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    else {
      return false
    }
  },
  routes,
})

// Router Guards
registerRouterGuards(router)

export { router, useRoute }
